type ApiFilterCondition = {
  fields: string[];
  value?: string | number | Array<string | number>;
  op:
    | 'eq'
    | 'not_eq'
    | 'starts_with'
    | 'includes'
    | 'ends_with'
    | 'contains'
    | 'not_contains'
    | 'gt'
    | 'gte'
    | 'lt'
    | 'lte'
    | 'between'
    | 'not_null'
    | 'is_null';
};

type ApiFilter = {
  and: ApiFilterCondition[];
};

/**
 * Map UI/URL filter values to API filter values
 * Naming convention:
 *   <field>_<operator>: value
 * Where operator can be _to or _from, for example price_from: 10, price_to: 100
 * We are assuming that all filter values are strings or numbers
 */
const mapFiltersToApi = (filters: Record<string, unknown>): ApiFilter => {
  const conditions: ApiFilterCondition[] = []

  for (const [ key, value ] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue
    if (typeof value !== 'string' && typeof value !== 'number' && !Array.isArray(value)) continue

    if (key.endsWith('_from')) {
      const field = key.replace('_from', '')
      conditions.push({
        fields: [ field ],
        value,
        op: 'gt',
      })
    }
    else if (key.endsWith('_to')) {
      const field = key.replace('_to', '')
      conditions.push({
        fields: [ field ],
        value,
        op: 'lt',
      })
    }
    else {
      conditions.push({
        fields: [ key ],
        value,
        op: 'contains',
      })
    }
  }

  return {
    and: conditions,
  }
}

export { mapFiltersToApi }
